import { Component, Input } from '@angular/core';
import { CurrentView } from '../../../api/models/user';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: false,
})
export class FooterComponent {
  @Input() isLogin = false;
  @Input() view!: CurrentView;
}
